import { createAction, props } from '@ngrx/store';
import { DataRequest } from 'app/services/ag-grid/query-builder/models/query-builder-request.model';
import { DeliveryTimeCategoryApiModel } from 'app/models/delivery-time-category-api.model';

export const loadDeliveryTimeCategories = createAction(
  '[Delivery time categories] Load',
  props<{ loadOptions?: DataRequest }>()
);

export const loadDeliveryTimeCategoriesSuccess = createAction(
  '[Delivery time categories] Load Successful',
  props<{ response: DeliveryTimeCategoryApiModel[] }>()
);

export const loadDeliveryTimeCategoriesFailed = createAction(
  '[Delivery time categories] Load Failure',
  props<{ error: any }>()
);
